import { Address } from 'components/DetailsPageBoilerplate/types';

export enum FIELDS {
  FIRM_NAME = 'firmName',
  FIRM_NAME_API = 'name',
  FCA = 'fca',
  SUBMISSION_ROUTE = 'submission_route',
  REGISTER_DATE = 'registeredAt',

  ADDRESS = 'address',
  FULL_ADDRESS = 'fullAddress',
  EMAIL = 'email',
  PHONE = 'phone',

  ADMINS = 'admins',

  ADMIN_ID = 'id',
  ADMIN_FIRST_NAME = 'firstName',
  ADMIN_LAST_NAME = 'lastName',
  ADMIN_NAME = 'name',
  ADMIN_FCA = 'fca',
  ADMIN_ADDRESS = 'address',
  ADMIN_FULL_ADDRESS = 'fullAddress',
  ADMIN_EMAIL = 'email',
  ADMIN_PHONE = 'phone',
  ADMIN_LMC_STATUS = 'isLMCActive',

  COMMISSION_TERMS = 'commissionTerms',
  STANDARD_COMMISSION_TERMS = 'standardCommissionTerms',
  ONGOING_COMMISSION_TERMS = 'ongoingCommissionTerms',
  ENHANCED_UPFRONT_COMMISSION_TERMS = 'enhancedUpfrontCommissionTerms',

  TERMS_OF_BUSINESS = 'termsOfBusiness',
  TOB_SIGNED_BY = 'tobSignedBy',
  TOB_SIGNED_DATE = 'tobSignedDate',
  TOB_VERSION = 'tobVersion',
  TOB_URL = 'tobUrl',

  FCA_STATUS = 'fcaStatus',
  LMC_STATUS = 'lmcStatus',
  DD_STATUS = 'dueDiligenceStatus',

  POSTCODE = 'postcode',
  HOUSE_NUMBER = 'houseNumber',
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
  CITY = 'city',
  COUNTY = 'county',

  NETWORK_NAME = 'network',
  CLUB_NAME = 'name',

  IS_PACKAGER = 'isPackager',
}

export enum FIELDS_LABELS {
  FIRM_NAME = 'Firm name',
  FCA = 'FCA number',
  SUBMISSION_ROUTE = 'Submission route',
  REGISTER_DATE = 'Date registered',
  ADDRESS = 'Address',
  EMAIL = 'Email address',
  PHONE = 'Contact no',
  ADMIN_NAME = 'Admin name',
  ADMIN_FCA = 'FCA number',
  ADMIN_ADDRESS = 'Address',
  ADMIN_EMAIL = 'Email address',
  ADMIN_PHONE = 'Contact No',
  ADMIN_LMC_STATUS = 'LMC status',
  COMMISSION_TERM = 'Commission term',
  STANDARD_COMMISSION_TERM = 'Standard Commission term',
  ONGOING_COMMISSION_TERM = 'Ongoing Commission term',
  ENHANCED_UPFRONT_COMMISSION_TERM = 'Enhanced up-front Commission term',
  FCA_STATUS = 'FCA status',
  LMC_STATUS = 'LMC status',
  BP_STATUS = 'Broker portal status',
  DD_STATUS_FIRM = 'Firm due diligence',
  DD_STATUS_CLUB = 'Club due diligence',
  DD_STATUS_NETWORK = 'Network due diligence',
  NETWORK_NAME = 'Network name',
  CLUB_NAME = 'Club name',
  TOB_SIGNED_BY = 'Signed by',
  TOB_SIGNED_DATE = 'Date',
  TOB_VERSION = 'Version',
  IS_PACKAGER = 'Packager',
}

export enum RADIO_VALUES {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DISABLED = 'disabled',
}

export type AdminType = {
  [FIELDS.ADMIN_ADDRESS]: Address;
  [FIELDS.ADMIN_FULL_ADDRESS]: string;
  [FIELDS.ADMIN_EMAIL]: string;
  [FIELDS.ADMIN_FCA]?: string;
  [FIELDS.ADMIN_LMC_STATUS]?: RADIO_VALUES;
  [FIELDS.ADMIN_ID]: string;
  [FIELDS.ADMIN_FIRST_NAME]: string;
  [FIELDS.ADMIN_LAST_NAME]: string;
  [FIELDS.ADMIN_NAME]: string;
  [FIELDS.ADMIN_PHONE]: string;
};

export interface CommissionTerm {
  id: string;
  type: string;
  name: string;
  value: string;
}
